import { DataTypeProvider } from '@devexpress/dx-react-grid';
import NRColoredBarVulnerabilitiesContainer from '../../../NRColoredBarVulnerabilitiesContainer/NRColoredBarVulnerabilitiesContainer';
import { withCustomParams } from '../../../NRReactGrid/withCustomParams';

const VulnerabilitiesBarFormatter = ({ value, row, handleIsLoading }) => {
  return (
    <NRColoredBarVulnerabilitiesContainer
      values={value}
      name={row?.name}
      version={row?.version}
      vendor={row?.vendor}
      {...(!!handleIsLoading ? { isLoading: handleIsLoading(row) } : {})}
    />
  );
};
export const VulnerabilitiesBarProvider = ({ extraParams, ...props }) => {
  const customFormatter = withCustomParams(VulnerabilitiesBarFormatter, extraParams);
  return <DataTypeProvider formatterComponent={customFormatter} {...props} />;
};
